import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Web3Provider } from './contexts/Web3Context';
import { UIProvider } from './contexts/UIContext';
import './styles/index.css';

// Ensure we're rendering to the root element
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <UIProvider>
        <Web3Provider>
          <App />
        </Web3Provider>
      </UIProvider>
    </BrowserRouter>
  </React.StrictMode>
);